import {
  DataGetter,
  CustomEventDetailTrackView,
  CustomEventDetailTrackEvent,
} from "../types";
import { debugLog } from "./debugLog";

export const CUSTOM_EVENT_TRACK_VIEW = "@argonaut/analytics/trackView";
export const CUSTOM_EVENT_TRACK_EVENT = "@argonaut/analytics/trackEvent";
export const CUSTOM_EVENT_CLEAR_VIEW = "@argonaut/analytics/clearEvent";

export const trackView = (viewDataGetters: Array<DataGetter>): void => {
  if (typeof document === "object") {
    debugLog(
      "Dispatched CUSTOM_EVENT_TRACK_VIEW event to document:",
      viewDataGetters,
    );

    document.dispatchEvent(
      new CustomEvent<CustomEventDetailTrackView>(CUSTOM_EVENT_TRACK_VIEW, {
        detail: { viewDataGetters },
      }),
    );
  }
};

export const trackEvent = (
  eventDataGetter: DataGetter,
  additionalViewDataGetters?: Array<DataGetter>,
): void => {
  if (typeof document === "object") {
    debugLog("Dispatched CUSTOM_EVENT_TRACK_EVENT event to document:", [
      eventDataGetter,
      ...(additionalViewDataGetters || []),
    ]);

    document.dispatchEvent(
      new CustomEvent<CustomEventDetailTrackEvent>(CUSTOM_EVENT_TRACK_EVENT, {
        detail: { eventDataGetter, additionalViewDataGetters },
      }),
    );
  }
};

export const clearView = (): void => {
  if (typeof document === "object") {
    debugLog("Dispatched CUSTOM_EVENT_CLEAR_VIEW event. ");

    document.dispatchEvent(new CustomEvent(CUSTOM_EVENT_CLEAR_VIEW));
  }
};
